// StatsSection.jsx
// Optional fonts (add to index.html for closer match):
// <link rel="preconnect" href="https://fonts.googleapis.com" />
// <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
// <link href="https://fonts.googleapis.com/css2?family=Archivo:wght@700;800&family=DM+Sans:wght@400;500;600&display=swap" rel="stylesheet" />

import React from "react";
import { Box, Container, Grid, Typography } from "@mui/material";
import CleaningServicesOutlinedIcon from "@mui/icons-material/CleaningServicesOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import EventAvailableOutlinedIcon from "@mui/icons-material/EventAvailableOutlined";

const StatsSection = () => {
  return (
    <>
      <style>{`
        :root {
          --about-bg: #0d0e10;
          --about-card-bg: #14151a;
          --about-card-stroke: #272935;
          --about-text-main: #ffffff;
          --about-text-muted: #c5c6d0;
          --about-kicker: #7ac142;
          --about-number-plus: #7ac142;
          --about-feature-bg: #14151a;
          --about-feature-border: #222431;
          --about-feature-text: #ffffff;
          --about-feature-muted: #b7bac7;
          --about-green: #7ac142;
          --about-yellow: #ffc93b;
          --about-blue: #287bff;
          --about-radius-lg: 40px;
          --about-radius-md: 26px;
          --about-img-radius: 32px;
          --about-shadow-card: 0 28px 80px rgba(0, 0, 0, 0.7);
          --about-font-heading: "Archivo", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
          --about-font-body: "DM Sans", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
          --about-anim-ease: cubic-bezier(0.23, 1, 0.32, 1);
        }

        .about-section {
          background: var(--about-bg);
          padding: 0px 16px 80px;
          position: relative;
          overflow: hidden;
        }

        .about-inner {
          max-width: 1200px;
          margin: 0 auto;
        }

        /* BUBBLES ON LEFT */
       .about-bubble {
  position: relative;
  left: 490;
  pointer-events: none;
  opacity: 0;
  animation-name: bubbleFloat;
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
}
@keyframes bubbleFloat {
  0% {
    transform: translateY(0) scale(0.2);
    opacity: 0;
  }

  10% {
    opacity: 0.8;
  }

  70% {
    transform: translateY(-250px) scale(1);
    opacity: 0.7;
  }

  90% {
    transform: translateY(-300px) scale(1.2);
    opacity: 0.3;
  }

  100% {
    transform: translateY(-320px) scale(1.4);
    opacity: 0;
  }
}
.about-bubble--1 {
  top: 520px;
  width: 66px;
  animation-duration: 8s;
  animation-delay: 0s;
}

.about-bubble--2 {
  top: 560px;
  width: 74px;
  animation-duration: 10s;
  animation-delay: 2s;
}

.about-bubble--3 {
  top: 600px;
  width: 86px;
  animation-duration: 7s;
  animation-delay: 1s;
}

.about-bubble--4 {
  top: 640px;
  width: 128px;
  animation-duration: 9s;
  animation-delay: 3s;
}

.about-bubble--5 {
  top: 680px;
  width: 136px;
  animation-duration: 11s;
  animation-delay: 4s;
}
.about-bubble--6 {
  top: 400px;
  width:146px;
  animation-duration: 11s;
  animation-delay: 4s;
}
.about-bubble--7 {
  top: 520px;
  width: 156px;
  animation-duration: 11s;
  animation-delay: 4s;
}
.about-bubble--8 {
  top: 690px;
  width: 166px;
  animation-duration: 11s;
  animation-delay: 4s;
}

        /* SECTION HEADING */
        .about-kicker-wrap {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          margin-bottom: 12px;
        }
        .about-kicker-line {
          width: 44px;
          height: 2px;
          border-radius: 999px;
          background: var(--about-kicker);
        }
        .about-kicker {
          font-family: var(--about-font-body);
          font-size: 12px;
          font-weight: 600;
          letter-spacing: 0.18em;
          text-transform: uppercase;
          color: var(--about-kicker);
        }

        .about-heading {
          font-family: var(--about-font-heading);
          font-weight: 800;
          font-size: 36px;
          line-height: 1.2;
          color: var(--about-text-main);
          margin: 0 0 8px;
        }

        .about-body-right {
          font-family: var(--about-font-body);
          font-size: 14px;
          line-height: 1.7;
          color: var(--about-text-muted);
          max-width: 420px;
          margin-bottom: 24px;
        }

        /* SPARKLE ICON (TOP RIGHT) */
        .about-sparkle {
          position: absolute;
          top: 40px;
          right: 24px;
          width: 54px;
        }

        /* MAIN GRID TOP (STATS CARD + RIGHT COLUMN) */
        .about-top-grid {
          align-items: flex-start;
        }

        /* LEFT STATS CARD */
        .about-stats-card {
          position: relative;
          background: var(--about-card-bg);
          border-radius: var(--about-radius-lg);
          padding: 40px 52px;
          margin-top: 28px;
          box-shadow: var(--about-shadow-card);
          overflow: hidden;
        }
/* FLEX FEATURES ROW */
.about-features-flex {
  display: flex;
  gap: 24px;
  margin-top: 40px;
  width: 100%;
  flex-wrap: wrap; 
}

/* Individual card wrapper */
.about-feature-flex-item {
  flex: 1 1 calc(33.333% - 16px);
  display: flex;
}

/* Card itself already styled – just ensure full height */
.about-feature-card {
  height: 100%;
}

/* Tablet */
@media (max-width: 960px) {
  .about-feature-flex {
    flex-wrap: wrap;
  }

  .about-feature-flex-item {
    flex: 1 1 calc(50% - 12px);
  }
}

/* Mobile */
@media (max-width: 600px) {
  .about-feature-flex {
    flex-direction: column;
  }

  .about-feature-flex-item {
    flex: 1 1 100%;
  }
}

        .about-stats-card::before,
        .about-stats-card::after {
          content: "";
          position: absolute;
          background: var(--about-card-stroke);
        }
        .about-stats-card::before {
          /* vertical line */
          width: 1px;
          top: 36px;
          bottom: 36px;
          left: 50%;
          transform: translateX(-0.5px);
        }
        .about-stats-card::after {
          /* horizontal line */
          height: 1px;
          left: 36px;
          right: 36px;
          top: 50%;
          transform: translateY(-0.5px);
        }

        .about-stat-grid {
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          row-gap: 44px;
          column-gap: 64px;
        }

        /* TOP SECTION FLEX */
.about-top-flex {
  display: flex;
  gap: 48px;
  align-items: flex-start;
  width: 100%;
}

/* Left & Right columns */
.about-top-left,
.about-top-right {
  flex: 1 1 50%;
}

/* Responsive */
@media (max-width: 959px) {
  .about-top-flex {
    flex-direction: column-reverse;
  }

  .about-top-left,
  .about-top-right {
    flex: 1 1 100%;
  }
}


        .about-stat-item h3 {
          font-family: var(--about-font-heading);
          font-weight: 800;
          font-size: 32px;
          line-height: 1.1;
          color: var(--about-text-main);
          margin: 0 0 4px;
        }

        .about-stat-item h3 span {
          color: var(--about-number-plus);
        }

        .about-stat-item p {
          font-family: var(--about-font-body);
          font-size: 14px;
          color: var(--about-text-muted);
          margin: 0;
        }

        /* DIAMOND ACCENTS */
        .about-stat-diamond {
          position: absolute;
          width: 18px;
          height: 18px;
          border-radius: 4px;
          transform: rotate(45deg);
          border: 2px solid var(--about-kicker);
          background: transparent;
        }
        .about-stat-diamond--top {
          top: 30px;
          left: 50%;
          transform: translateX(-50%) rotate(45deg);
          border-color: #ffc93b;
        }
        .about-stat-diamond--bottom {
          bottom: 30px;
          left: 50%;
          transform: translateX(-50%) rotate(45deg);
          border-color: #ffc93b;
        }
        .about-stat-diamond--left {
          left: 24px;
          top: 50%;
          transform: translateY(-50%) rotate(45deg);
          border-color: var(--about-green);
        }
        .about-stat-diamond--right {
          right: 24px;
          top: 50%;
          transform: translateY(-50%) rotate(45deg);
          border-color: #ffc93b;
        }

        /* RIGHT IMAGE COLUMN */
        .about-right-top {
          position: relative;
          padding-top: 4px;
        }

        .about-image-wrap {
          position: relative;
          border-radius: var(--about-img-radius);
          overflow: hidden;
          box-shadow: var(--about-shadow-card);
        }

        .about-main-img {
          display: block;
          width: 100%;
          height: auto;
        }

        /* BOTTOM FEATURE CARDS */
    .about-features-row {
  width: 100%;
  margin-top: 40px;
}

.about-feature-card {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  background: var(--about-feature-bg);
  border-radius: 26px;
  border: 1px solid var(--about-feature-border);
  padding: 20px 24px;
  width: 100%;          /* important: fill Grid column */
  box-sizing: border-box;/* important: include padding in width */
  flex-wrap: wrap;       /* allow content to wrap inside card */
}

.about-feature-icon-box {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;       /* icon doesn’t shrink */
}

.about-feature-icon {
  font-size: 28px;
  color: #fff;
}

.about-feature-content {
  flex: 1 1 0;           /* allows text to shrink and wrap */
  min-width: 0;          /* critical: prevents overflow breaking layout */
}

.about-feature-heading {
  font-family: var(--about-font-heading);
  font-size: 16px;
  font-weight: 700;
  color: var(--about-feature-text);
  margin-bottom: 4px;
  word-break: break-word; /* wrap long words */
}

.about-feature-desc {
  font-family: var(--about-font-body);
  font-size: 13px;
  line-height: 1.7;
  color: var(--about-feature-muted);
  word-break: break-word; /* wrap long text */
}

/* Color variants */
.about-feature--green .about-feature-icon-box { background: var(--about-green); }
.about-feature--yellow .about-feature-icon-box { background: var(--about-yellow); }
.about-feature--blue .about-feature-icon-box { background: var(--about-blue); }

/* Responsive */
@media (max-width: 960px) {
  .about-feature-card { flex-direction: row; padding: 16px 18px; }
}

@media (max-width: 600px) {
  .about-feature-card { flex-direction: column; align-items: center; text-align: center; }
  .about-feature-icon-box { margin-bottom: 12px; }
  .about-feature-content { width: 100%; }
  .about-bubble {position: absolute; }
}



        /* SIMPLE FADE-IN ONCE */
        .about-fade {
          opacity: 0;
          transform: translate3d(0, 40px, 0);
          animation: about-fade-up 900ms var(--about-anim-ease) forwards;
        }
        .about-fade-delay {
          animation-delay: 120ms;
        }

        @keyframes about-fade-up {
          to {
            opacity: 1;
            transform: translate3d(0, 0, 0);
          }
        }

        @media (prefers-reduced-motion: reduce) {
          .about-fade {
            animation: none;
            opacity: 1;
            transform: none;
          }
        }

        /* RESPONSIVE */
        @media (max-width: 1199px) {
          .about-section {
            padding-top: 80px;
            padding-bottom: 72px;
          }
        }

        @media (max-width: 959px) {
          .about-top-grid {
            flex-direction: column-reverse;
          }
          .about-image-wrap {
            margin-bottom: 32px;
          }
          .about-sparkle {
            display: none;
          }
        }

        @media (max-width: 599px) {
          .about-section {
            padding-top: 64px;
            padding-bottom: 64px;
          }
          .about-heading {
            font-size: 28px;
          }
          .about-stats-card {
            padding: 30px 28px;
          }
          .about-stat-grid {
            column-gap: 32px;
            row-gap: 32px;
          }
          .about-feature-card {
            padding: 18px 20px;
          }
        }
          
      `}</style>

      <Box component="section" className="about-section">
        {/* left-side bubbles */}
        <img
          src="https://html.themehour.net/kleanix/demo/assets/img/shape/bubble_4.png"
          alt=""
          className="about-bubble about-bubble--1"
        />
        <img
          src="https://html.themehour.net/kleanix/demo/assets/img/shape/bubble_5.png"
          alt=""
          className="about-bubble about-bubble--2"
        />
        <img
          src="https://html.themehour.net/kleanix/demo/assets/img/shape/bubble_7.png"
          alt=""
          className="about-bubble about-bubble--3"
        />
        <img
          src="https://html.themehour.net/kleanix/demo/assets/img/shape/bubble_9.png"
          alt=""
          className="about-bubble about-bubble--4"
        />
        <img
          src="https://html.themehour.net/kleanix/demo/assets/img/shape/bubble_10.png"
          alt=""
          className="about-bubble about-bubble--5"
        />
        <img
          src="https://html.themehour.net/kleanix/demo/assets/img/shape/bubble_10.png"
          alt=""
          className="about-bubble about-bubble--6"
        />
        <img
          src="https://html.themehour.net/kleanix/demo/assets/img/shape/bubble_10.png"
          alt=""
          className="about-bubble about-bubble--7"
        />
        <img
          src="https://html.themehour.net/kleanix/demo/assets/img/shape/bubble_10.png"
          alt=""
          className="about-bubble about-bubble--8"
        />

        <Container className="about-inner">
          {/* main star / sparkle on the right */}
          <img
            src="https://html.themehour.net/kleanix/demo/assets/img/shape/home-3-shape-1.svg"
            alt=""
            className="about-sparkle"
          />

          {/* TOP GRID: LEFT STATS, RIGHT TEXT+IMAGE */}
          <Grid
            container
            spacing={6}
            alignItems="flex-start"
            className="about-top-grid"
          >
            {/* LEFT COLUMN */}
      <Box className="about-top-flex">
  {/* LEFT COLUMN */}
  <Box className="about-top-left">
    <Box className="about-fade">
      <Box className="about-kicker-wrap">
        <Box className="about-kicker-line" />
        <Typography className="about-kicker">ABOUT US</Typography>
        <Box className="about-kicker-line" />
      </Box>

      <Typography component="h2" className="about-heading">
        Your Home’s Best Friend in
        <br />
        Bloomington & Monroe County
      </Typography>

      <Box className="about-stats-card">
        <div className="about-stat-diamond about-stat-diamond--top" />
        <div className="about-stat-diamond about-stat-diamond--bottom" />
        <div className="about-stat-diamond about-stat-diamond--left" />
        <div className="about-stat-diamond about-stat-diamond--right" />

        <div className="about-stat-grid">
          <div className="about-stat-item">
            <h3>26M<span>+</span></h3>
            <p>Project Finish</p>
          </div>
          <div className="about-stat-item">
            <h3>16M<span>+</span></h3>
            <p>Satisfied Our Customers</p>
          </div>
          <div className="about-stat-item">
            <h3>180<span>+</span></h3>
            <p>Expert Members</p>
          </div>
          <div className="about-stat-item">
            <h3>120<span>+</span></h3>
            <p>Company Award Winner</p>
          </div>
        </div>
      </Box>
    </Box>
  </Box>

  {/* RIGHT COLUMN */}
  <Box className="about-top-right">
    <Box className="about-right-top about-fade about-fade-delay">
      <Typography className="about-body-right">
      Managing a home shouldn't require a rolodex of contractors. At Rite Home Pros, we’ve combined the three most critical home services—HVAC, Water Mitigation, and Cleaning—under one roof. We are local experts dedicated to protecting your biggest investment. Whether it’s 2 AM water damage or your scheduled spring cleaning, you have one trusted number to call. 
      </Typography>

      <Box className="about-image-wrap">
        <img
          src="https://html.themehour.net/kleanix/demo/assets/img/about/about_3_1.jpg"
          alt=""
          className="about-main-img"
        />
      </Box>
    </Box>
  </Box>
</Box>


            {/* RIGHT COLUMN */}
          </Grid>

{/* BOTTOM FEATURES – FLEX BASED */}
<Box className="about-features-flex">
  {[
    {
      title: "Local Experts",
      desc: "Serving Bloomington and surrounding areas with pride. ",
      icon: <CleaningServicesOutlinedIcon />,
      color: "green",
    },
    {
      title: "24/7 Response",
      desc: "Emergency mitigation when you need it most.",
      icon: <AccessTimeOutlinedIcon />,
      color: "yellow",
    },
    {
      title: "Proactive Care",
      desc: "We fix issues before they become disasters. ",
      icon: <EventAvailableOutlinedIcon />,
      color: "blue",
    },
  ].map((feature, index) => (
    <Box key={index} className="about-feature-flex-item">
      <Box className={`about-feature-card about-feature--${feature.color}`}>
        <Box className="about-feature-icon-box">
          {feature.icon}
        </Box>

        <Box className="about-feature-content">
          <Typography className="about-feature-heading">
            {feature.title}
          </Typography>
          <Typography className="about-feature-desc">
            {feature.desc}
          </Typography>
        </Box>
      </Box>
    </Box>
  ))}
</Box>




        </Container>
      </Box>
    </>
  );
};

export default StatsSection;

